import { API_ROUTE_ADMIN_EMPLOYEE_CONSENTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

export type OriginalEmployeeConsent = {
  id: number
  text: string
  createdDate: string
  user: {
    id: number
    firstName: string
    lastName: string
  } | null
  customerHead: {
    id: number
    name: string
  } | null
  customer: {
    id: number
    name: string
  } | null
  consentsGiven: number
  consentsTotalToBeGiven: number
  consentsNotYetGiven: number
  employeeConsentStatus: {
    name: 'Draft' | 'Published' | 'Closed'
  }
}

const IS_NEW_BACKEND_API = true

export async function getConsents() {
  const consents = await get<OriginalEmployeeConsent[]>(
    API_ROUTE_ADMIN_EMPLOYEE_CONSENTS,
    IS_NEW_BACKEND_API
  )
  const parsedConsents = consents.map(consent => ({
    ...consent,
    isGlobal: Boolean(consent.customerHead),
  }))

  return parsedConsents
}
